module.exports = __webpack_public_path__ + "img/Preguntas frecuentes 576px-1.a2cf5334.png";